import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const CTASection = () => {
  const navigate = useNavigate();

  return (
    <section className="py-20 px-6 bg-secondary/20">
      <div className="max-w-4xl mx-auto text-center">
        <div className="bg-gradient-to-br from-primary/20 via-accent/20 to-primary/20 border border-primary/30 rounded-2xl p-12 shadow-elevation-3">
          <div className="w-20 h-20 bg-primary/20 rounded-full flex items-center justify-center mx-auto mb-6">
            <Icon name="Rocket" size={40} color="var(--color-primary)" strokeWidth={2} />
          </div>

          <h2 className="text-4xl md:text-5xl font-bold text-foreground mb-4">
            Ready to Transform Your Onboarding?
          </h2>
          
          <p className="text-xl text-muted-foreground mb-8 max-w-2xl mx-auto">
            Join 500+ companies that have revolutionized their employee onboarding experience with Bee Wise
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-8">
            <Button
              variant="default"
              size="xl"
              iconName="ArrowRight"
              iconPosition="right"
              onClick={() => navigate('/login-authentication')}
              className="min-w-[220px]"
            >
              Start Free Trial
            </Button>
            <Button
              variant="outline"
              size="xl"
              iconName="Calendar"
              iconPosition="left"
              className="min-w-[220px]"
            >
              Schedule Demo
            </Button>
          </div>

          <div className="flex flex-wrap justify-center gap-6 text-sm text-muted-foreground">
            <div className="flex items-center gap-2">
              <Icon name="CheckCircle2" size={16} color="var(--color-success)" />
              <span>No credit card required</span>
            </div>
            <div className="flex items-center gap-2">
              <Icon name="CheckCircle2" size={16} color="var(--color-success)" />
              <span>14-day free trial</span>
            </div>
            <div className="flex items-center gap-2">
              <Icon name="CheckCircle2" size={16} color="var(--color-success)" />
              <span>Cancel anytime</span>
            </div>
          </div>
        </div>

        <div className="mt-12 grid grid-cols-2 md:grid-cols-4 gap-6">
          {[
            { icon: 'Shield', label: 'Enterprise Security' },
            { icon: 'Zap', label: 'Quick Setup' },
            { icon: 'Users', label: 'Dedicated Support' },
            { icon: 'TrendingUp', label: 'Proven ROI' }
          ]?.map((feature, index) => (
            <div key={index} className="flex flex-col items-center gap-2">
              <div className="w-12 h-12 bg-card border border-border rounded-lg flex items-center justify-center">
                <Icon name={feature?.icon} size={20} color="var(--color-primary)" />
              </div>
              <span className="text-sm text-muted-foreground">{feature?.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CTASection;